import { useSelector } from "react-redux";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import { getAvailableStations } from "src/modules/device/duck/selectors";
import Stations from "./Stations";

function MultiBabyManager({ parentStation }) {
  const {
    babyStations,
    primaryStation,
    babyStationSelect,
    toggleTilesView,
    updatePrimaryStation,
    multiBabyManager,
    togglePushToTalk,
    toggleSeeMe,
    toggleSeeMeButton,
    stopMonitoring,
    toggleMonitoringMode
  } = parentStation;

  const availableStations = useSelector(getAvailableStations);
  const nearbyStations = availableStations.reduce((all, one) => {
    if (babyStations[one.jid]) return all;
    all[one.jid] = one;
    return all;
  }, {});

  async function handleStationSwitch(station) {
    const {
      jid,
      pushToTalkState,
      seeMeState,
      cameraAndFlashlightState,
      flashlightManager,
      mode
    } = primaryStation;
    if (station.jid === jid) return;
    await updatePrimaryStation(station, true);

    if (mode === "video") {
      await toggleMonitoringMode(jid, true);
      if (pushToTalkState === "on") {
        toggleSeeMeButton();
        await togglePushToTalk(jid);
      }
    } else {
      if (pushToTalkState === "on") {
        toggleSeeMeButton();
        await togglePushToTalk(jid);
      }
      if (seeMeState === "on") {
        await toggleSeeMe(jid);
      }
      if (cameraAndFlashlightState.flashlightEnabled) {
        flashlightManager.turnOff();
      }
    }
  }

  async function onTilesViewToggle() {
    const { pushToTalkState, seeMeState } = primaryStation;
    if (seeMeState === "on") {
      await toggleSeeMe();
    }
    if (pushToTalkState === "on") {
      toggleSeeMeButton();
      await togglePushToTalk();
    }
  }

  const renderTilesToggle = Object.keys(babyStations).length > 1;
  const renderStationPickerToggle =
    !primaryStation.error &&
    Object.keys(nearbyStations).length !== 0 &&
    Object.keys(babyStations).length < 4;

  return (
    <Stations
      multiBabyManager={multiBabyManager}
      nearbyStations={nearbyStations}
      toggleTilesView={toggleTilesView}
      focusedStation={primaryStation}
      connectedStations={babyStations}
      babyStationSelect={babyStationSelect}
      renderTilesToggle={renderTilesToggle}
      handleStationSwitch={handleStationSwitch}
      renderStationPickerToggle={renderStationPickerToggle}
      onTilesViewToggle={onTilesViewToggle}
      mode={primaryStation?.mode}
      stopMonitoring={stopMonitoring}
    />
  );
}

export default withParentStation(MultiBabyManager);
